import React, {useState, useEffect} from 'react';
import {useHistory} from 'react-router-dom';

import apiCall from '../../Utils/apiCall';
import { displayQuoteNumber } from '../../Utils/displayQuoteNumber'

import './QuoteEditPartTwo.css';

// custom components

//carbon components
import {
  Grid,
  Row,
  Column,
  Icon,
  Button,
  TextInput,
  DatePicker,
  DatePickerInput,
  Search,
  ToastNotification,
 } from 'carbon-components-react';

 import { ArrowLeft20, Checkmark20 } from '@carbon/icons-react';

 // COMPONENT FUNCTION
 function QuoteEditPartTwo(props) {

   // props
  const {user, token, setStep2, step2, quoteToEdit, setQuoteToEdit, currentQuoteItems} = props;

  //variables
  const history = useHistory();

  // set state
  const [contactInfo, setContactInfo] = useState(null)
  const [quoteExtraInfo, setQuoteExtraInfo] = useState(null)
  const [notification, setNotification] = useState(false)
  const [notificationContent, setNotificationContent] = useState({
    title: "",
    caption: "",
    type: "info"
  })

  useEffect( () => {

    console.log("this my material", quoteToEdit);

    const fromContact = quoteToEdit.from;
    const toContact = quoteToEdit.to;

    const extraInfoObject = { created_at: quoteToEdit.created_at, expiration: quoteToEdit.expiration }

    let contactInfoObject = {from: quoteToEdit.from, to: quoteToEdit.to}

    setContactInfo(contactInfoObject)
    setQuoteExtraInfo(extraInfoObject)

  }, []);

  // functions
  const _handleCompleteEditQuote = async () => {


    // SAFETY CHECKS - to prevent user to submit empty data fields
    //salesman
    if ( !contactInfo.from.name || !contactInfo.from.phone) {
      // setNotification(true)
      // setNotificationContent({
      //   title: "Error",
      //   caption: "Make sure the sales contact info is filled out",
      //   type: "error"
      // })
      // setTimeout( () => {
      //   setNotification(false)
      // }, 3000 )
      // return
    }
    //customer
    if (!contactInfo.to.name || !contactInfo.to.phone || !contactInfo.to.email || !contactInfo.to.address1 || !contactInfo.to.address2 ) {
      // setNotification(true)
      // setNotificationContent({
      //   title: "Error",
      //   caption: "Make sure that all the fields in the customer information part are filled out",
      //   type: "error"
      // })
      // setTimeout( () => {
      //   setNotification(false)
      // }, 3000 )
      // return
    }
    //extra info
    console.log(quoteExtraInfo);
    if (!quoteExtraInfo.expiration || isNaN(quoteExtraInfo.expiration)) {
      // setNotification(true)
      // setNotificationContent({
      //   title: "Error",
      //   caption: "Make sure that the quote expiration is set",
      //   type: "error"
      // })
      // setTimeout( () => {
      //   setNotification(false)
      // }, 3000 )
      // return
    }


    let quoteObject = {}
    quoteObject.items = currentQuoteItems
    quoteObject.from = contactInfo.from
    quoteObject.to = contactInfo.to
    quoteObject.created_at = quoteExtraInfo.created_at
    quoteObject.expiration = quoteExtraInfo.expiration
    console.log("QUOTE READY:", quoteObject);

    //CALL API AND SAVE QUOTE

    const options = {
      method: "PUT",
      body: JSON.stringify(quoteObject)
    }
    const headers = {
      'Content-Type': 'application/json'
    }
    const apiPath = `/quotes/${quoteToEdit._id}`

    const result = await apiCall(token, apiPath, options, headers);

    console.log(">>>>>>>", result);
    if (result.err) {
      console.error(result.err)
      setNotificationContent({
        title: "Error",
        caption: "There was an error in updating this quote.",
        type: "error"
      })
      setNotification(true)
      return
    }

    setNotificationContent({
      title: "Success",
      caption: result.message,
      type: "success"
    })
    setNotification(true)
    setTimeout( () => {
      history.push('/quote-database')
    }, 3000)

  }

  if (!contactInfo) {
    return (
      <div id="homeContainer">
        Loading...
      </div>
    )
  }

  return (
    <div id="homeContainer">
      { notification ?  <ToastNotification lowContrast={false} className="appNotification slide-in-top" title={notificationContent.title} kind={notificationContent.type} caption={notificationContent.caption} /> : null }
      <h3 id="mainTitle">Modify Quote #{displayQuoteNumber(quoteToEdit.quoteNumber)}</h3>
      <div id="actionBtnsContainer">
        <div id="leftActionBtns">
          <Button id="backBtn" onClick={() => setStep2(0)} renderIcon={ArrowLeft20}>Back</Button>
        </div>
        <div id="completeQuopteBtn">
          <Button onClick={() => _handleCompleteEditQuote()} renderIcon={Checkmark20}>Complete</Button>
        </div>
      </div>

      <Grid id="formContainer">
        <Row condensed>
          <Column lg={5} md={12}>
            <div id="toForm">
              <h4 className={"formTitle"}>Sales Contact</h4>
              <TextInput
                id="from-name-field-email"
                labelText="Email"
                value={quoteToEdit.from.email}
                disabled
                placeholder="Input email"
                style={{ marginBottom: '1rem' }}
              />
              <TextInput
                id="from-name-field-name"
                labelText="Name"
                value={contactInfo.from.name}
                style={{ marginBottom: '1rem' }}
                onChange={(e) => setContactInfo({...contactInfo, from: {...contactInfo.from, name: e.target.value} })}
              />
              <TextInput
                id="phone-number-name-field"
                labelText="Phone Number"
                value={contactInfo.from.phone}
                style={{ marginBottom: '1rem' }}
                onChange={(e) => setContactInfo({...contactInfo, from: {...contactInfo.from, phone: e.target.value}} )}
              />
            </div>

                <h4 className={"formTitle"}>Additional Details</h4>
                  <DatePicker style={{marginBottom: '1rem'}}
                    datePickerType="single"
                    value={quoteExtraInfo.expiration}
                    onChange={ (e) => setQuoteExtraInfo({...quoteExtraInfo, expiration: new Date(e)}) }
                    >
                    <DatePickerInput
                      placeholder="mm/dd/yyyy"
                      labelText="Quote Expiration Date"
                      id="quote-expiration-field"
                    />
                  </DatePicker>

          </Column>
          <Column lg={2} md={0}>
          </Column>
          <Column lg={5} md={12}>
            <div id="toForm">
              <h4 className={"formTitle"}>Customer Information</h4>
              {/*<TextInput
                id="ticker-to-field"
                labelText="Ticker"
                value={contactInfo.to.ticker}
                style={{ marginBottom: '1rem'}}
                onChange={(e) => setContactInfo({...contactInfo, to: {...contactInfo.to, ticker: e.target.value}} )}
              />*/}
              <TextInput
                id="name-to-field"
                labelText="Name"
                value={contactInfo.to.name}
                style={{ marginBottom: '1rem'}}
                onChange={(e) => setContactInfo({...contactInfo, to: {...contactInfo.to, name: e.target.value}} )}
              />
              <TextInput
                id="phone-number-to-field"
                labelText="Phone Number"
                value={contactInfo.to.phone}
                style={{ marginBottom: '1rem' }}
                onChange={(e) => setContactInfo({...contactInfo, to: {...contactInfo.to, phone: e.target.value}} )}
              />
              <TextInput
                id="email-to-field"
                labelText="Email"
                value={contactInfo.to.email}
                style={{ marginBottom: '1rem' }}
                onChange={(e) => setContactInfo({...contactInfo, to: {...contactInfo.to, email: e.target.value} })}

              />
              <TextInput
                id="address-to-field"
                labelText="Address Line 1"
                value={contactInfo.to.address1}
                style={{ marginBottom: '1rem' }}
                onChange={(e) => setContactInfo({...contactInfo, to: {...contactInfo.to, address1: e.target.value} })}

              />
              <TextInput
                id="address-to-field"
                labelText="Address Line 2"
                value={contactInfo.to.address2}
                style={{ marginBottom: '1rem' }}
                onChange={(e) => setContactInfo({...contactInfo, to: {...contactInfo.to, address2: e.target.value} })}

              />
            </div>
          </Column>
        </Row>
      </Grid>

    </div>
  );
}

export default QuoteEditPartTwo;
